<!-- @TODO Artem: Styles like on mockup -->
@if (visible) {
  <div
    [ngClass]="'p-confirm-popup p-component bg-white'"
    [ngStyle]="style"
    [class]="styleClass"
    (click)="onOverlayClick($event)"
    [@animation]="{ value: 'open', params: { showTransitionParams: showTransitionOptions, hideTransitionParams: hideTransitionOptions } }"
    (@animation.start)="onAnimationStart($event)"
    (@animation.done)="onAnimationEnd($event)">
    <div #content class="p-confirm-popup-content">
      <span class="p-confirm-popup-message" [innerHTML]="confirmation.message"></span>
    </div>
    <div class="p-confirm-popup-footer align-h-space-between">
      @if (confirmation.rejectVisible !== false) {
        <button
          type="button"
          class="btn basic w-100"
          (click)="onReject()">
          {{rejectButtonLabel}}
        </button>
      }
      @if (confirmation.acceptVisible !== false) {
        <button
          type="button"
          class="btn primary w-100"
          (click)="onAccept()">
          {{acceptButtonLabel}}
        </button>
      }
    </div>
  </div>
}
